import type { ManagedCallSummary } from '@repo/sdk/gen'

/**
 * `call/list-managed` lists every call of each residence, one for each
 * academic year. The pages that show one card for each residence take the
 * current call of it, as the API does: the latest year that is not a draft,
 * else the draft.
 */
export function currentCallOfEach(list: ManagedCallSummary[]) {
	const current = new Map<string, ManagedCallSummary>()
	for (const item of list) {
		const held = current.get(item.residence.id)
		if (!held || isLater(item, held)) {
			current.set(item.residence.id, item)
		}
	}
	return list.filter((item) => current.get(item.residence.id) === item)
}

/** The current call among the calls of one residence. */
export function currentCallOf(calls: ManagedCallSummary[]) {
	return calls.reduce<ManagedCallSummary | undefined>(
		(held, item) => (!held || isLater(item, held) ? item : held),
		undefined
	)
}

const isLater = (item: ManagedCallSummary, held: ManagedCallSummary) => {
	const draft = (value: ManagedCallSummary) => value.call.state === 'draft'
	if (draft(item) !== draft(held)) {
		return draft(held)
	}
	return item.call.academicYear > held.call.academicYear
}
